export default __webpack_public_path__ + "static/media/cageminni.123d9894.jpg";